/** Calendar overlay prefs (localStorage). Defaults: both on. */

export const CALENDAR_DISPLAY_PREFS_KEY = 'cg_calendar_display';

const DEFAULTS = {
    showClasses: true,
    showCancelledClasses: true,
};

function normalize(raw) {
    if (!raw || typeof raw !== 'object') return { ...DEFAULTS };
    return {
        showClasses: raw.showClasses !== false,
        showCancelledClasses: raw.showCancelledClasses !== false,
    };
}

export function loadCalendarDisplayPrefs() {
    try {
        const raw = localStorage.getItem(CALENDAR_DISPLAY_PREFS_KEY);
        if (!raw) return { ...DEFAULTS };
        return normalize(JSON.parse(raw));
    } catch {
        return { ...DEFAULTS };
    }
}

export function saveCalendarDisplayPrefs(prefs) {
    const next = normalize(prefs);
    try {
        localStorage.setItem(CALENDAR_DISPLAY_PREFS_KEY, JSON.stringify(next));
    } catch {
        // ignore quota / private mode
    }
    return next;
}
